export default function (id) {
  let lastScrollY = 0;
  let isBlocking = false;
  const moveTo = new MoveTo({
    duration: 1000,
    callback () {
      isBlocking = false;
    }
  });
  const moveToTarget = document.getElementById(id);
  
  window.addEventListener('scroll', (e) => {
    if (isBlocking) return e.preventDefault();
    const scroll = () => {
      if ((window.scrollY > lastScrollY) && (window.scrollY < window.innerHeight) && !isBlocking) {
        isBlocking = true;
        e.preventDefault();

        let distance = moveToTarget.getBoundingClientRect().top;
        if (id.slice(-1) === '2') {
          distance -= 64;
        }
        moveTo.move(distance);
      }
      lastScrollY = window.scrollY;
    };
    const f = _.debounce(scroll, 200);
    f();
  });
}